/**
 * Convert resolved labor rate array (from GET /api/bid-estimation/rates/resolved)
 * to nested shape (legacy format: { labor: {rate, defaultCrewSize}, ... }).
 */
export const toNestedShape = (rates) => {
  if (!rates || !Array.isArray(rates)) return {}
  const result = {}
  for (const r of rates) {
    if (!r.roleKey) continue
    result[r.roleKey] = {
      rate: r.hourlyRate || 0,
      defaultCrewSize: r.defaultCrewSize || 1
    }
  }
  return result
}

export const toEquipmentNestedShape = toNestedShape

export const toFlatShape = (rates) => {
  if (!rates || !Array.isArray(rates)) return {}
  const result = {}
  for (const r of rates) {
    if (!r.roleKey) continue
    result[`${r.roleKey}Rate`] = r.hourlyRate || 0
  }
  return result
}
